import React from 'react'

const HeadTop = () => {
    return (
        <>
            <div className="head-top">
                <div className="container">
                    <ul className="top-cntct float-left">
                        <li>
                            <a href="#">
                                <i className="fa fa-facebook" />
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i className="fa fa-twitter" />
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i className="fa fa-google-plus" />
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                <i className="fa fa-instagram" />
                            </a>
                        </li>
                        <li>
                            <a href="tel:8809678100530">
                                <i className="fa fa-phone" /> <span>+8809678-100530</span>
                            </a>
                        </li>
                    </ul>
                    <ul className="info-lst float-right">
                        <li>
                            <div id="currency" className="btn-group">
                                <button className="btn-link dropdown-toggle" data-toggle="dropdown">
                                    <span>
                                        $ USD <i className="fa fa-caret-down" />
                                    </span>
                                </button>
                                <ul className="dropdown-menu" style={{ display: "none" }}>
                                    <li>
                                        <button
                                            className="currency-select btn btn-link btn-block"
                                            type="button"
                                            name="Taka"
                                        >
                                            ৳ Taka
                                        </button>
                                    </li>
                                    <li>
                                        <button
                                            className="currency-select btn btn-link btn-block"
                                            type="button"
                                            name="USD"
                                        >
                                            $ US Dollar
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        
                        <li>
                            <i className="fa fa-user-o" />
                            <a href="#" data-toggle="modal" data-target="#login">
                                Register / Sign in
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default HeadTop